  import Repository from '@/repositories/marketing'
  const resource = '/widgets'

  export default {
    getCampaignsByDate(config){
      return Repository.get(`${resource}/campaigns_by_date.json`, config)
    },
    getCampaignDates(config){
        return Repository.get(`${resource}/campaign_dates.json`, config)
    },
    getEmailAddressByDomain(config){
        return Repository.get(`${resource}/email_address_by_domain.json`, config)
    },
    getEmailStatistics(config){
        return Repository.get(`${resource}/email_statistics.json`, config)
    },
    getPushAppUsage(config){
        return Repository.get(`${resource}/push_app_usage.json`, config)
    },
    findContact(config){
        return Repository.get(`${resource}/find_contact.json`, config)
    },
    getAvgContactLifecycle(config){
        return Repository.get(`${resource}/avg_contact_lifecycle.json`, config)
    },
    getAppEngagement(config){
        return Repository.get(`${resource}/app_engagement.json`, config)
    },
    getPushApplications(config){
        return Repository.get(`/mobile_applications.json`, config)
    },
    getEventStackRank(config){
        return Repository.get(`${resource}/event_stack_rank.json`, config)
    },
    getIspReport(data,config){
        return Repository.post(`${resource}/isp_report.json`, data, config)
    },
    getReleaseNotes(config){
        return Repository.get(`${resource}/release_notes.json`, config)
    },
    getPushDaySummary(config){
        return Repository.get(`${resource}/push_day_summary.json`, config)
    },
    getEventTimeSeries(config){
        return Repository.get(`${resource}/event_time_series.json`, config)
    },
    getPushEvents(){
        return Repository.get(`/push_events.json`)
    },
    getRecentTweets(config){
        return Repository.get(`${resource}/recent_tweets.json`, config)
    },
    getGrowthReportSummary(config){
        return Repository.get(`${resource}/growth_report_summary.json`, config)
    },
    getRecentUpdatedList(config){
        return Repository.get(`${resource}/recent_updated_list.json`, config)
    },
    getMonthlyEmailUsage(config){
        return Repository.get(`${resource}/monthly_email_usage.json`, config)
    },
    getEmailVolume(config){
        return Repository.get(`${resource}/email_volume.json`, config)
    },
    getCampaignStatistics(config){
        return Repository.get(`${resource}/campaign_statistics.json`, config)
    },
    getCampaignRevenue(config){
        return Repository.get(`${resource}/campaign_revenue.json`, config)
    },
    getDeliverabilityScore(config){
        return Repository.get(`${resource}/deliverability_score.json`, config)
    },
    getOpenClickByDataCenter(params){
        return Repository.get(`${resource}/open_clicks_by_datacenter.json`, {params})
    },
    getSMSVolume(config){
        return Repository.get(`${resource}/sms_volume.json`, config)
    },
  }
